export default [
  require('./slides/01-intro'),
  require('./slides/02-back-to-list'),
  require('./slides/03-this-week'),
  require('./slides/04-what-are-loops'),
  require('./slides/05-loops'),
  require('./slides/06-loop-summary'),
  require('./slides/07-post-intro'),
  require('./slides/08-template-tags'),
  require('./slides/09-our-post')
]



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/index.js